import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function useValidator() {
  const {t} = useI18n();

  yup.addMethod(yup.string, 'phone', function (countryCode = 'UA') {
    return this.test('phone', function (value) {
      const { path, createError } = this;

      if (!value) return true;
      const phoneNumber = parsePhoneNumberFromString(value, countryCode);

      if (!phoneNumber || !phoneNumber.isValid()) {
        return createError({ path, message: t('validator.phoneNumber') });
      }

      return true;
    });
  });

  yup.setLocale({
    mixed: {
      required: ({label}) => t('validator.required', {field: label}),
      notType: ({label}) => t('validator.required', {field: label}),
    },
    number: {
      positive: ({label}) => t('validator.positive', {field: label}),
    },
    array: {
      min: ({label, min}) => t('validator.minArray', {field: label, min}),
    },
    string: {
      phone: ({label}) => t('validator.phoneNumber', {field: label}),
    }
  })

  async function validate(schema: any, data: any) {
    try {
      await schema.validate(data, {abortEarly: false});
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        const errors = {};
        err.inner.forEach((error: any) => {
          errors[error.path] = error.errors;
        })
        throw errors;
      } else {
        throw err;
      }
    }
  }

  return {
    yup,
    validate,
  }
}
